// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"8d4feb65","453":"841fb9fb","455":"7a5f9277","977":"8c571d41"}[chunkId] + ".chunk.js";
};